import { useIsMobile } from '@snapchat/snap-design-system-marketing';

/** @deprecated - Use the one from sdsm. */
export const useMobileLayout = (): boolean => {
  return useIsMobile();
};
